<template>
	<!-- A small panel for showing the insurance info of an order row -->
	<div class="panel panel-body insured-order-row p-4">
		<div class="info">
			<ximg
				:src="iconSrc"
				ariaLabel="insurance icon"
				role="img"
			/>
			<span class="ml-3">Försäkrad med {{ insuranceInfo.insurance.name }}</span>,
			<span style="white-space: nowrap">{{ insuranceInfo.quantity }} st à {{ insuranceInfo.unitPrice }} kr</span>
		</div>
	</div>
</template>
<script>
import { convertToCdnUrl } from 'utils';
export default {
	props: {
		insuranceInfo: {
			type: Object,
			required: true,
		},
	},
	data () {
		return {};
	},
	methods: {

	},
	computed: {
		iconSrc() {
			if (this.insuranceInfo.provider === 1) {
				return convertToCdnUrl('/img/icons/carepack_shield_white.svg');
			} else if(this.insuranceInfo.provider === 2) {
				return convertToCdnUrl('/api/dynimg/category/apple/cf102d');
			}
		},
	},
};
</script>